import request, { gql } from "graphql-request";
import BASEURL from "../Utils/Baseurl";

export const createcalldetails = gql`
  mutation createcalldetails($input: CreateCallDetailsInput!) {
    createCallDetail(input: $input) {
      success
    }
  }
`;

export const updatecalldetails = gql`
  mutation updatecalldetails($input: UpdateCallDetailsInput!) {
    updateCallDetail(input: $input) {
      success
    }
  }
`;

export const createemail = gql`
  mutation createemail($createemail: CreateEmailDetailsInput!) {
    createEmaildetails(input: $createemail) {
      success
    }
  }
`;
export const createvisted = gql`
  mutation createvisted($input: CreateVisitInput!) {
    createVisit(input: $input) {
      success
      message
    }
  }
`;
export const updatevisited = gql`
 mutation updatevisited($input:UpdateVisitInput!){
  updateVisit(input:$input){
    success
    message
  }
}
`;
export const updateemaildetails = gql`
  mutation updateemaildetails($input: UpdateEmailDetailsInput!) {
    updateEmaildetails(input: $input) {
      success
    }
  }
`;
export const addCallService = async (values) => {
  let callstatus = false;
  try {
    const res = await request(BASEURL, createcalldetails, {
      input: { ...values },
    });

    callstatus = true;

  } catch (err) {
    console.error(err.message, "call error");
    callstatus = false;
  }

  return callstatus;
};
export const updateCallService = async (id, values) => {
  let updateStatus = false;
  try {
    const res = await request(BASEURL, updatecalldetails, {
      input: {
        id: id,
        ...values,
      },
    });
    updateStatus = true;
  } catch (err) {
    console.error(err.message, " error");
    updateStatus = false;
  }

  return updateStatus;
};
export const addMailService = async (values) => {
  let mailstatus = false;
  try {
    const res = await request(BASEURL, createemail, {
      createemail: { ...values },
    });
    mailstatus = true;

  } catch (err) {
    console.error(err.message, "mail error");
    mailstatus = false;
  }

  return mailstatus;
};
export const addVisitService = async (values) => {
  let createStatus = false;
  let errormessage;
  try {
    const res = await request(BASEURL, createvisted, {
      input: {
        ...values,
      },
    });
    if (res?.createVisit.success) {
      createStatus = true;
    } else {
      createStatus = false;
      errormessage = res?.createVisit?.message || "An error occurred"; 
    }
  } catch (err) {
    //errormessage=err.res.createVisit?.message,
    console.error(err, "addAppoinmentService error");
  }

  return { createStatus, errormessage };
};
export const updateVisitService = async (values, id) => {
  let updateStatus = false;
  let errormessage;
  try {
    const res = await request(BASEURL, updatevisited, {
      input: {
        id: id,
        ...values,
      },
    });
    if (res?.updateVisit.success) {
      updateStatus = true;
    } else {
      updateStatus = false;
      errormessage = res?.updateVisit?.message || "An error occurred"; 
    }
    
  } catch (err) {
    console.error(err.message, "updateAppointmentService error");
    updateStatus = false;
  }

  return {updateStatus,errormessage};
};
export const updateMailService = async (id, values) => {
  let updateStatus = false;
  try {
    const res = await request(BASEURL, updateemaildetails, {
      input: {
        id: id,
        ...values,
      },
    });
    
    updateStatus = true;
  } catch (err) {
    console.error(err.message, " error");
    updateStatus = false;
  }

  return updateStatus;
};
